import { render, staticRenderFns } from "./downloadZone.vue?vue&type=template&id=a0184372&scoped=true&"
import script from "./downloadZone.vue?vue&type=script&lang=js&"
export * from "./downloadZone.vue?vue&type=script&lang=js&"
import style0 from "./downloadZone.vue?vue&type=style&index=0&id=a0184372&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0184372",
  null
  
)

export default component.exports